/** 盒子观众端 PK/多人PK 查询接口（不含主播端操作接口） */
const pkConfig = {
  // 正在pk中的信息
  pkingInfo: `/authApi/show/v1/pk/pkingInfo`,
  // pk贡献榜单
  contributionRank: `/authApi/show/v1/pk/contributionRank`,
  // 获取pk结果
  pkResult: `/authApi/show/v1/pk/pkResult`,
  // 检查是否第一次进入pk （96秀的 盒子先不用
  checkDayEnterPkLive: '/authApi/show/v1/pk/checkDayEnterPkLive',
  // 多人pk正在pk中的信息
  mutilPkingInfo: '/authApi/show/v1/pkMulti/pkingInfo',
  // 正在pk中参与主播的信息
  pkPartInfo: '/authApi/show/v1/pk/pkPartInfo',
  // 多人pk贡献榜单
  mutilPkContributionRank: '/authApi/show/v1/pkMulti/contributionRank',
  // 连线主播数据(观众端，当前主播在第一位)
  connectedpkMultiUserListCurrent: '/authApi/show/v1/pkMulti/connect/audience/connectedUserList'
};

export default pkConfig;
